import React from 'react';
import { MuiBox, Box, FlexBox, Button, Typography, Grid } from '@kis-technologies/kis-ui';
import { actions as adminsActions } from 'store/admins';
import { CreateNewUserSuccessProps } from '../types';
import { useActions } from 'hooks/useActions';
import { useStyles } from '../styled';

export const CreateNewUserSuccess = (props: CreateNewUserSuccessProps) => {
  // ACTION CREATOR
  const { resetAction } = useActions({ resetAction: adminsActions.resetAction });

  const classes = useStyles();

  // SUCCESS CLICK
  const onSuccessClick = () => {
    // PROPS.ONCONFIRM AND RESET ACTION
    props.onConfirm();
    resetAction();
  };

  return (
    <FlexBox justify="center" flexOverride="1 1 0%" padding="0 0 11" margin="3 0 0" sx={{ color: 'black' }}>
      <Grid className={classes.createUserSuccessContainer}>
        <Box flexOverride="none" fullWidth>
          <Typography className={classes.createUserSuccessHeader}>New User Created</Typography>
        </Box>
        <Box flexOverride="none" fullWidth>
          <Typography className={classes.createUserSuccessSubHeader}>
            You have successfully added a new user. An email has been sent containing their credentials.
          </Typography>
        </Box>
        {/* BUTTON TO FIRE SUCCESS CLICK */}
        <MuiBox className={classes.createUserViewBox}>
          <Button customSize="large" onClick={onSuccessClick} className={classes.createUserViewButton}>
            View Users
          </Button>
        </MuiBox>
      </Grid>
    </FlexBox>
  );
};
